export default __webpack_public_path__ + "static/media/benefit_1.cf7a9daa.svg";